import { t } from "i18next";

export const CheckMeal = (meal: string) => {
  return t("child_food_" + meal);
};
